module.exports = __webpack_public_path__ + "static/media/bannerbigsee.3f55a423.jpg";